import AuthApi from '../services/auth/AuthApi'
import OidcApi from '../services/auth/OidcApi'
import resetAppState from '@/mixins/reset-app-state'
import router from '@/router'

export const logout = {
  methods: {
    async logout() {
      const refreshToken = localStorage.getItem('refresh_token')
      const oidcLogoutUrl = OidcApi.logoutUrl()
      try {
        if (refreshToken && !OidcApi.configured()) {
          await AuthApi.logout(refreshToken)
        }
      } catch (error) {
        console.warn('Logout API failed')
      } finally {
        resetAppState()
        if (oidcLogoutUrl) {
          window.location.assign(oidcLogoutUrl)
        } else if (router.currentRoute.path !== '/') {
          await router.push('/')
        }
      }
    },
  },
}
